var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mapbox-map"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.isAttemptingToScroll)?_c('div',{staticClass:"mapbox-map__scroll-msg"},[_c('p',[_vm._v(" Hold Ctrl to Zoom ")])]):_vm._e()]),_c('div',{attrs:{"id":_vm.elemId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }